import { StyleSheet } from 'react-native';
import { LILAC_200 } from '@airtel/air-design-system';
export var getUpsellCellStyles = () => {
  return StyleSheet.create({
    container: {
      flex: 1,
      minHeight: '100%',
      flexShrink: 1,
      backgroundColor: LILAC_200
    }
  });
};